<template>
    <GZ-ModalMainTmpl icon="icon-hipster">
        <span slot="title">Добавить сотрудника</span>
        
        <section slot="content">
            <StaffAddEditForm />
        </section>
    </GZ-ModalMainTmpl>
</template>

<script>
import StaffAddEditForm from '@/components/custom/admin/views/staff/StaffAddEditForm'

export default {
    name: 'AddStaff',

    components: {
        StaffAddEditForm
    }
}
</script>